module.exports = "/img/offroad_vehicle.68bfb9bc.png";